import { Link } from "@/components/Link";
import { InfoBoxItem } from "../InfoBoxItem";
import { routeFactory } from "@/RouteFactory";
import { Txt } from "@stenajs-webui/core";

export const CustomerBaseInformation: React.FC<{
  custIndex: string;
  custNo: number;
  custStatNo: number | string | null;
  custInvoiceCurrency?: string;
}> = ({ custIndex, custNo, custStatNo, custInvoiceCurrency }) => (
  <>
    <InfoBoxItem leftContent={"Index"} rightContent={custIndex} />
    <InfoBoxItem
      leftContent={"No."}
      rightContent={
        <Link
          to={routeFactory.productAndPrice.customer.customer({
            customerId: String(custNo),
          })}
        >
          <Txt size="small" color="unset">
            {custNo}
          </Txt>
        </Link>
      }
    />
    <InfoBoxItem
      leftContent={"Stat. No"}
      rightContent={
        <Link
          to={routeFactory.productAndPrice.customer.customer({
            customerId: String(custStatNo),
          })}
        >
          <Txt size="small" color="unset">
            {custStatNo}
          </Txt>
        </Link>
      }
    />
    <InfoBoxItem
      leftContent={"Invoice curr."}
      rightContent={custInvoiceCurrency}
    />
  </>
);
